/**
 * Created by youzipi on 17/7/21.
 */

import Vue from 'vue'
import cookie from 'vue-cookie'
import axios from 'axios'
import { Message } from 'element-ui'

axios.defaults.baseURL = process.env.API
// axios.defaults.headers.common['Authorization'] = localStorage.getItem('token') || '1'
axios.defaults.headers.common['Authorization'] = cookie.get('token') || '1'
// axios.defaults.headers.common['AUTH_KEY'] = 'h8aKtn23k09pb0Q'

// not work
// axios.defaults.withCredentials = true

// const http = Vue.prototype.$http
const http = axios

const RequestHandler = (config) => {
  let url = config.url
  let ignoreErr = config.ignoreErr
  return new Promise((resolve, reject) => {
    let isServerOk = true
    let httpStatus = 200
    let noAuthType = 'ERROR.NO_AUTH'

    let _config = {
      withCredentials: true,
      ...config,
    }

    http(_config)
      .then(res => {
        httpStatus = res.status
        isServerOk = (res.status >= 200 && res.status < 300)
        return res
      })
      .then(res => {
        if (__DEV__) {
          console.info('res=', url, httpStatus, '\n', res)
        }

        if (isServerOk) {
          // debugger
          // 数据正确返回
          // todo remove
          if (res.data.type === noAuthType) {
            window.location.href = process.env.ACCT_API
          }
          resolve(res.data)
        }
        else {
          if (res.status === 401) {
            window.location.href = process.env.ACCT_API
          }
          reject(res.response)
        }

      }).catch(err => {
      // debugger
      if (err.response) {
        let errData = err.response.data
        console.log('err=', JSON.parse(JSON.stringify(err)))
        if (__DEV__) {
          console.log('errData=', JSON.parse(JSON.stringify(errData)))
        }
        let _errData = JSON.parse(JSON.stringify(errData))
        // if (_errData.code === 'ERROR.NO_AUTH') {
        //   localStorage.clear()
        //   window.location.href = process.env.ACCT_API
        // }

        if (!ignoreErr) {
          Message({type: 'error', message: err.response.data.message})
        }
        // if (errData.code === errorCodes.INVALID_TOKEN) {
        //   localStorage.clear()
        //   window.$tip(errData.code)
        //   // debugger
        //   location.href = '/#/wx-redirect'
        // }
      }
      // _reject = reject || defaultReject
      reject(err.response.data)
      // reject({
      //   code: '-1',
      //   message: '网络错误'
      // })
    })
    // .done()
  })
}

const ZFetch = function () {
  const request = function (config) {
    return RequestHandler(config)
  }

  const get = function (config) {
    return request({
      ...config,
      method: 'GET',
    })
  }
  const post = function (config) {
    return request({
      ...config,
      method: 'POST',
    })
  }
  const put = function (config) {
    return request({
      ...config,
      method: 'PUT',
    })
  }
  const patch = function (config) {
    return request({
      ...config,
      method: 'PATCH',
    })
  }
  const _delete = function (config) {
    return request({
      ...config,
      method: 'DELETE',
    })
  }
  const setToken = function (token) {
    http.defaults.headers.common['Authorization'] = token
    http.defaults.headers.common['AUTH_KEY'] = 'h8aKtn23k09pb0Q'
    return false
  }
  const clearToken = function () {
    http.defaults.headers.common['Authorization'] = ''
    return false
  }

  return {
    get: get,
    post: post,
    put: put,
    patch: patch,
    delete: _delete,
    setToken: setToken,
    clearToken: clearToken,
  }
}

const fetch = new ZFetch()

export default fetch



// WEBPACK FOOTER //
// ./src/utils/fetch.js